/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPagingResponseOfPassengerDataFileFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeAgGridClientQuery, serializePagingResponseOfPassengerDataFile, type AgGridClientQuery, type PagingResponseOfPassengerDataFile, type ProblemDetails } from '../models/index.js';
// @ts-ignore
import { ApproveRequestBuilderRequestsMetadata, type ApproveRequestBuilder } from './approve/index.js';
// @ts-ignore
import { DownloadRequestBuilderNavigationMetadata, type DownloadRequestBuilder } from './download/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /PassengerDataFile
 */
export interface PassengerDataFileRequestBuilder extends BaseRequestBuilder<PassengerDataFileRequestBuilder> {
    /**
     * The Approve property
     */
    get approve(): ApproveRequestBuilder;
    /**
     * The Download property
     */
    get download(): DownloadRequestBuilder;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagingResponseOfPassengerDataFile>}
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     post(body: AgGridClientQuery, requestConfiguration?: RequestConfiguration<PassengerDataFileRequestBuilderPostQueryParameters> | undefined) : Promise<PagingResponseOfPassengerDataFile | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: AgGridClientQuery, requestConfiguration?: RequestConfiguration<PassengerDataFileRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
export interface PassengerDataFileRequestBuilderPostQueryParameters {
    showOnlyRetries?: boolean;
    showUpcomingFlights?: boolean;
}
/**
 * Uri template for the request builder.
 */
export const PassengerDataFileRequestBuilderUriTemplate = "{+baseurl}/PassengerDataFile?showOnlyRetries={showOnlyRetries}&showUpcomingFlights={showUpcomingFlights}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const PassengerDataFileRequestBuilderNavigationMetadata: Record<Exclude<keyof PassengerDataFileRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    approve: {
        requestsMetadata: ApproveRequestBuilderRequestsMetadata,
    },
    download: {
        navigationMetadata: DownloadRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const PassengerDataFileRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: PassengerDataFileRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagingResponseOfPassengerDataFileFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAgGridClientQuery,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
